export default {
  Android: function () {
    return navigator.userAgent.match(/Android/i)
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i)
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i)
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i)
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i)
  },
  any: function () {
    return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows())
  },
  none: function () {
    return (!this.any())
  },
  isTouch: function () {
    return !!('ontouchstart' in window || (navigator.msMaxTouchPoints > 0) || navigator.maxTouchPoints)
  }
}
